"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AxelarProvider = void 0;
const ethers_1 = require("ethers");
const sdk_1 = require("@0xsquid/sdk");
const types_1 = require("@0xsquid/sdk/dist/types");
const schemas_1 = require("@dcl/schemas");
const ERC20_1 = require("../abis/ERC20");
const MarketplaceV2_1 = require("../abis/MarketplaceV2");
const ERC721_1 = require("../abis/ERC721");
const Marketplace_1 = require("../abis/Marketplace");
const CollectionStore_1 = require("../abis/CollectionStore");
const contracts_1 = require("../contracts");
const types_2 = require("../types");
const utils_1 = require("./utils");
class AxelarProvider {
    constructor(squidURL) {
        this.initialized = false;
        this.squidMulticall = '0x4fd39C9E151e50580779bd04B1f7eCc310079fd3'; // Squid calling contract
        this.squid = new sdk_1.Squid({
            baseUrl: squidURL,
            integratorId: 'decentraland-sdk'
        });
        this.squid.init();
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.squid.initialized) {
                yield this.squid.init();
                this.initialized = true;
            }
        });
    }
    isLibInitialized() {
        return this.squid.initialized;
    }
    getFromAmount(fromAmountParams) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.squid.getFromAmount(fromAmountParams);
        });
    }
    getSupportedTokens() {
        return this.squid.tokens;
    }
    getSupportedChains() {
        return this.squid.chains;
    }
    executeRoute(route, provider) {
        return __awaiter(this, void 0, void 0, function* () {
            const signer = yield new ethers_1.ethers.providers.Web3Provider(provider).getSigner();
            if (!this.squid.initialized) {
                yield this.init();
            }
            // @ts-ignore
            // tslint:disable-next-line
            const txResponse = (yield this.squid.executeRoute({
                route: route.route,
                signer
            }));
            return txResponse.wait();
        });
    }
    buyNFT(provider, buyNFTCrossChainData) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = yield this.getBuyNFTRoute(buyNFTCrossChainData);
            const tx = yield this.executeRoute(route, provider);
            return tx.transactionHash;
        });
    }
    getBuyNFTRoute(buyNFTCrossChainData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.squid.initialized) {
                yield this.init();
            }
            const { fromAddress, fromAmount, fromChain, fromToken, toChain, toAmount, // the item price
            enableExpress = true, // TODO: check if we need this
            slippage = 1, // 1 is "normal" slippage. Always set to 1
            nft: { collectionAddress, price, tokenId } } = buyNFTCrossChainData;
            const ERC20ContractInterface = new ethers_1.ethers.utils.Interface(ERC20_1.ERC20);
            const marketplaceContractABI = toChain === schemas_1.ChainId.MATIC_MAINNET ? MarketplaceV2_1.MarketplaceV2 : Marketplace_1.Marketplace;
            const marketplaceInterface = new ethers_1.ethers.utils.Interface(marketplaceContractABI);
            const ERC721ContractInterface = new ethers_1.ethers.utils.Interface(ERC721_1.ERC721);
            const destinyChainMANA = contracts_1.getContract(types_2.ContractName.MANAToken, toChain)
                .address;
            const destinyChainMarketplace = contracts_1.getContract(toChain === schemas_1.ChainId.MATIC_MAINNET
                ? types_2.ContractName.MarketplaceV2
                : types_2.ContractName.Marketplace, toChain).address;
            return this.squid.getRoute({
                fromAddress,
                fromAmount,
                fromToken,
                fromChain: fromChain.toString(),
                toToken: destinyChainMANA,
                toChain: toChain.toString(),
                toAddress: destinyChainMarketplace,
                enableBoost: enableExpress,
                slippageConfig: {
                    autoMode: slippage
                },
                postHook: {
                    chainType: types_1.ChainType.EVM,
                    fundAmount: '1',
                    fundToken: destinyChainMANA,
                    calls: [
                        // ===================================
                        // Approve MANA to be spent by Decentraland contract
                        // ===================================
                        {
                            chainType: types_1.ChainType.EVM,
                            callType: types_1.SquidCallType.DEFAULT,
                            target: destinyChainMANA,
                            value: '0',
                            callData: ERC20ContractInterface.encodeFunctionData('approve', [
                                destinyChainMarketplace,
                                toAmount
                            ]),
                            payload: {
                                tokenAddress: utils_1.NATIVE_TOKEN,
                                inputPos: 0
                            },
                            estimatedGas: '50000'
                        },
                        // ===================================
                        // EXECUTE ORDER
                        // ===================================
                        {
                            chainType: types_1.ChainType.EVM,
                            callType: types_1.SquidCallType.DEFAULT,
                            target: destinyChainMarketplace,
                            value: '0',
                            callData: marketplaceInterface.encodeFunctionData('executeOrder', [
                                collectionAddress,
                                tokenId,
                                price
                            ]),
                            payload: {
                                tokenAddress: utils_1.NATIVE_TOKEN,
                                inputPos: 0
                            },
                            estimatedGas: '300000'
                        },
                        // ===================================
                        // Transfer NFT to buyer
                        // ===================================
                        {
                            chainType: types_1.ChainType.EVM,
                            callType: types_1.SquidCallType.DEFAULT,
                            target: collectionAddress,
                            value: '0',
                            callData: ERC721ContractInterface.encodeFunctionData('safeTransferFrom(address, address, uint256)', [this.squidMulticall, fromAddress, tokenId]),
                            payload: {
                                tokenAddress: utils_1.NATIVE_TOKEN,
                                inputPos: 1
                            },
                            estimatedGas: '50000'
                        },
                        // ===================================
                        // Transfer remaining MANA to buyer
                        // ===================================
                        {
                            chainType: types_1.ChainType.EVM,
                            callType: types_1.SquidCallType.FULL_TOKEN_BALANCE,
                            target: destinyChainMANA,
                            value: '0',
                            callData: ERC20ContractInterface.encodeFunctionData('transfer', [
                                fromAddress,
                                '0'
                            ]),
                            payload: {
                                tokenAddress: destinyChainMANA,
                                // This will replace the parameter at index 1 in the encoded Function,
                                //  with FULL_TOKEN_BALANCE (instead of "0")
                                inputPos: 1
                            },
                            estimatedGas: '50000'
                        }
                    ]
                }
            });
        });
    }
    // MINT
    mintNFT(provider, mintNFTCrossChainData) {
        return __awaiter(this, void 0, void 0, function* () {
            const route = yield this.getMintNFTRoute(mintNFTCrossChainData);
            const tx = yield this.executeRoute(route, provider);
            return tx.transactionHash;
        });
    }
    getMintNFTRoute(buyNFTCrossChainData) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.squid.initialized) {
                yield this.init();
            }
            const { fromAddress, fromAmount, fromChain, fromToken, toChain, toAmount, // the item price
            enableExpress = true, slippage = 1, // 1 is "normal" slippage. Always set to 1
            item: { collectionAddress, price, itemId } } = buyNFTCrossChainData;
            const ERC20ContractInterface = new ethers_1.ethers.utils.Interface(ERC20_1.ERC20);
            const collectionStoreInterface = new ethers_1.ethers.utils.Interface(CollectionStore_1.CollectionStore);
            const destinyChainMANA = contracts_1.getContract(types_2.ContractName.MANAToken, toChain)
                .address;
            const destinyChaiCollectionStoreAddress = contracts_1.getContract(types_2.ContractName.CollectionStore, toChain).address;
            return this.squid.getRoute({
                fromAddress,
                fromAmount,
                fromToken,
                fromChain: fromChain.toString(),
                toToken: destinyChainMANA,
                toChain: toChain.toString(),
                toAddress: fromAddress,
                enableBoost: enableExpress,
                slippageConfig: {
                    autoMode: slippage
                },
                postHook: {
                    chainType: types_1.ChainType.EVM,
                    fundAmount: '1',
                    fundToken: destinyChainMANA,
                    calls: [
                        // ===================================
                        // Approve MANA to be spent by Decentraland contract
                        // ===================================
                        {
                            chainType: types_1.ChainType.EVM,
                            callType: types_1.SquidCallType.DEFAULT,
                            target: destinyChainMANA,
                            value: '0',
                            callData: ERC20ContractInterface.encodeFunctionData('approve', [
                                contracts_1.getContract(types_2.ContractName.CollectionStore, toChain).address,
                                toAmount
                            ]),
                            payload: {
                                tokenAddress: utils_1.NATIVE_TOKEN,
                                inputPos: 0
                            },
                            estimatedGas: '50000'
                        },
                        // ===================================
                        // BUY ITEM
                        // ===================================
                        {
                            chainType: types_1.ChainType.EVM,
                            callType: types_1.SquidCallType.DEFAULT,
                            target: destinyChaiCollectionStoreAddress,
                            value: '0',
                            callData: collectionStoreInterface.encodeFunctionData('buy((address,uint256[],uint256[],address[])[])', [[[collectionAddress, [itemId], [price], [fromAddress]]]]),
                            payload: {
                                tokenAddress: utils_1.NATIVE_TOKEN,
                                inputPos: 0
                            },
                            estimatedGas: '300000' // TODO: where do we get this value from?
                        },
                        // ===================================
                        // Transfer remaining MANA to buyer
                        // ===================================
                        {
                            chainType: types_1.ChainType.EVM,
                            callType: types_1.SquidCallType.FULL_TOKEN_BALANCE,
                            target: destinyChainMANA,
                            value: '0',
                            callData: ERC20ContractInterface.encodeFunctionData('transfer', [
                                fromAddress,
                                '0'
                            ]),
                            payload: {
                                tokenAddress: destinyChainMANA,
                                // This will replace the parameter at index 1 in the encoded Function,
                                //  with FULL_TOKEN_BALANCE (instead of "0")
                                inputPos: 1
                            },
                            estimatedGas: '50000'
                        }
                    ]
                }
            });
        });
    }
}
exports.AxelarProvider = AxelarProvider;
//# sourceMappingURL=AxelarProvider.js.map